/** The sentence for a Start that failed (STORY-141).
 *
 * A course reaches the session service one relay pass after it is created, so a Start pressed
 * inside that second answers 404 `course_unknown`: that gets its own sentence, anything else
 * the general one. Kept free of value imports and reading `code` structurally, as
 * `rewrites.ts` does, so that Node's own test runner can load it. */
export function startErrorKey(error: unknown): string {
  const code = error && typeof error === "object" ? (error as { code?: unknown }).code : undefined;
  return code === "course_unknown" ? "course.startNotReady" : "course.startFailed";
}
